import { useState, useEffect } from 'react'
import _ from 'lodash'
import { shallowEqual } from 'react-redux'

const useFilingStatus = (returnStatii, filer) => {

    const [groupedStatii, setGroupedStatii] = useState([])

    const [dashboardStatus, setDashboardStatus] = useState('')
    const [netfileStatus, setNetfileStatus] = useState('')

    const [CRAStatus, setCRAStatus] = useState(null)
    const [RQStatus, setRQStatus] = useState(null)
    const [T1135Status, setT1135Status] = useState(null)

    useEffect(() => {
        let filtered = returnStatii.filter(s => s.fileContext === filer)

        // find individual statii for each submissionType
        let grouped = _.groupBy(filtered || [], 'submissionType')

        // CRA
        let craLatest = (grouped['CRA'] || grouped['REFILECRA'] || [])
            .sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified))
            .find(status => status.fileContext === filer)
        setCRAStatus(craLatest)

        // RQ
        let rqLatest = (grouped['RQ'] || [])
            .sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified))
            .find(status => status.fileContext === filer)
        setRQStatus(rqLatest)

        // T1135
        let T1135Latest = (grouped['T1135'] || [])
            .sort((a, b) => new Date(b.lastModified) - new Date(a.lastModified))
            .find(status => status.fileContext === filer)
        setT1135Status(T1135Latest)

        // yay! we have the latest status for each submission Type (that exists). Gather 'em up.
        let submissionStatii = [craLatest, rqLatest, T1135Latest].filter(s => !!s)

        // determine the dashboard status
        let dashboardStatii = submissionStatii.map(s => s.dashboardStatus)
        let hasGlobalDashboardStatus = _(dashboardStatii).every(x => x === dashboardStatii[0])

        setDashboardStatus(hasGlobalDashboardStatus ? dashboardStatii[0] :
            dashboardStatii.includes("IN_PROGRESS") ? "IN_PROGRESS" :
                dashboardStatii.includes("NETFILED") ? "NETFILED" :
                    dashboardStatii.includes("PAPERFILED") ? "PAPERFILED" :
                        (dashboardStatii.includes("REFILED") || dashboardStatii.includes("REFILE_ERROR") || dashboardStatii.includes("REFILE_STARTED")) ? "REFILED" : "IN_PROGRESS")

        // now, determine netfile status
        let netfileStatii = submissionStatii.map(s => !!s && s.status)
        let hasGlobalNetfileStatus = _(netfileStatii).every(s => s === netfileStatii[0])

        setNetfileStatus(hasGlobalNetfileStatus ? netfileStatii[0] :
            netfileStatii.includes("REJECT") ? "REJECT" :
                netfileStatii.includes("ERROR") ? "ERROR" :
                    netfileStatii.includes("SUCCESS") ? "SUCCESS" : "")

        // set the grouped statii to return
        if (!shallowEqual(grouped, groupedStatii)) {
            setGroupedStatii(grouped)
        }
    }, [returnStatii])

    return { dashboardStatus, netfileStatus, CRAStatus, RQStatus, T1135Status, groupedStatii }
}

export default useFilingStatus